import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import LogoBlackSVG from '@assets/images/logo/sws-logo-black.svg';
import { CrossSolid } from '@simplywallst/ui-core/icons';

import { Row, Column } from '@simplywallst/ui-core';

export const GuestRegistration = styled(Row)`
  position: relative;
  background: white;
  width: 100%;
  max-width: 384px;
  ${media.lgUp`
    max-width: 960px;
    min-height: 652px;
  `}
`;

export const Form = styled(Column)`
  padding: ${({ theme }) => theme.x2spacePx}px
    ${({ theme }) => theme.x4spacePx}px;
`;

export const SWSLogoBlack = styled(LogoBlackSVG)`
  ${media.lgUp`
    display: none;
  `}
  width: 100%;
  max-width: 150px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const FormIntroduction = styled('div')`
  text-align: center;
`;

export const FormHeader = styled('h1')`
  ${({ theme }) => theme.typography.xLarge}

  margin-bottom: ${({ theme }) => theme.x3spacePx}px;

  ${media.xsOnly`
    font-size: ${({ theme }) => theme.x2space}rem;
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  `}
`;

export const FormSubHeader = styled('p')`
  ${({ theme }) => theme.typography.small}
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  ${media.xsOnly`
    font-size: ${({ theme }) => theme.x2space - 0.3}rem;
    margin-bottom: ${({ theme }) => theme.x2space}rem;
  `}
`;

export const TermsAndConditionsWrapper = styled('div')`
  ${media.xsOnly`
    margin-top: -${({ theme }) => theme.x1space}rem;
  `}
`;

export const EmailFormWrapper = styled('div')`
  max-width: 320px;
  margin-top: -${({ theme }) => theme.x1space}rem;
  margin-left: auto;
  margin-right: auto;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x4spacePx}px;
  `}
`;

export const CloseIcon = styled(CrossSolid)`
  cursor: pointer;
  position: absolute;
  right: ${({ theme }) => theme.x1spacePx}px;
  top: ${({ theme }) => theme.x1spacePx}px;
  fill: ${({ theme }) => theme.color.white};
  z-index: 1;
  ${media.mdDown`
    fill: ${({ theme }) => theme.color.black};
  `}
`;
